// extracted by mini-css-extract-plugin
export default {"showResultContainer":"SwitchShowResultsImmediately_showResultContainer__Op0gW"};